export default __webpack_public_path__ + "static/media/main-how-it-works-us-app.b055a3a7.png";